import { useCallback, useState } from "react";
import { generateAndSaveResumePdf } from "../lib/resumePdf";

/**
 * Manages the "Download PDF" flow: loading state, waiting for fonts,
 * and falling back to the browser print dialog on error.
 */
export function usePdfExport(sheetRef, onBeforeCapture) {
  const [pdfLoading, setPdfLoading] = useState(false);

  const downloadPDF = useCallback(async () => {
    if (!sheetRef.current) return;
    setPdfLoading(true);
    if (onBeforeCapture) onBeforeCapture();

    try {
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      await new Promise((resolve) => setTimeout(resolve, 600));
      await generateAndSaveResumePdf(sheetRef.current);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.error("PDF export failed", err);
      }
      window.print();
    } finally {
      setPdfLoading(false);
    }
  }, [sheetRef, onBeforeCapture]);

  return { pdfLoading, downloadPDF };
}
